/* UtilFullscreen util */
export default class UtilFullscreen {
    /**
     * Get the singleton instance
     */
    static getInstance(document) {
        if (!UtilFullscreen.instance) {
            UtilFullscreen.instance = new UtilFullscreen(document);
        }
        return UtilFullscreen.instance;
    }
    constructor(document) {
        this.document = document;
    }
    enterFullscreen(element) {
        const requestFullscreen = element.requestFullscreen ||
            // @ts-expect-error migrated from ts-ignore
            element.mozRequestFullScreen /* Firefox */ ||
            // @ts-expect-error migrated from ts-ignore
            element.webkitRequestFullscreen /* Safari */ ||
            // @ts-expect-error migrated from ts-ignore
            element.msRequestFullscreen; /* IE11 */
        if (requestFullscreen) {
            requestFullscreen.call(element);
        }
    }
    exitFullscreen() {
        const exitFullscreen = this.document.exitFullscreen ||
            // @ts-expect-error migrated from ts-ignore
            this.document.mozCancelFullScreen /* Firefox */ ||
            // @ts-expect-error migrated from ts-ignore
            this.document.webkitExitFullscreen /* Safari */ ||
            // @ts-expect-error migrated from ts-ignore
            this.document.msExitFullscreen; /* IE11 */
        if (exitFullscreen) {
            exitFullscreen.call(this.document);
        }
    }
    onFullscreenChanged(listener) {
        const events = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];
        for (const eventName of events) {
            this.document.addEventListener(eventName, (event) => {
                const payload = {
                    event: event,
                    fullscreenActive: this.isFullscreenActive(),
                };
                listener(payload);
            });
        }
    }
    /**
     * Check if the fullscreen mode is active.
     */
    isFullscreenActive() {
        const fullscreenElement = this.document.fullscreenElement ||
            // @ts-expect-error migrated from ts-ignore
            this.document.mozFullScreenElement /* Firefox */ ||
            // @ts-expect-error migrated from ts-ignore
            this.document.msFullscreenElement; /* IE11 */
        return !!fullscreenElement;
    }
}
